var render = function render(_c,_vm){return _c('c-product-buttongroup',_vm._b({class:['product-configurator-editor-text', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id,"buttons":_vm.props.items,"vertical":_vm.props.overrideVertical ? true: _vm.props.items.length > 2,"block":""}},'c-product-buttongroup',_vm.data.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }